import { useState } from 'react';
import Sidebar from './Sidebar';
import type { TabType } from '../App';
import { type BackendUserWithPlan } from '../userService';
import './Layout.css';

export type LayoutChildProps = {
    showMenu: boolean;
    onMenuClick: () => void;
};

type LayoutProps = {
    children: (props: LayoutChildProps) => React.ReactNode;
    activeTab: TabType;
    onTabChange: (tab: TabType, subTab?: string) => void;
    educationSubTab?: string;
    networkingSubTab?: string;
    userData: BackendUserWithPlan | null;
    onChatSelect?: (projectId: string, chatId: string) => void;
    onNewDirectChat?: () => void;
    selectedChatId?: string;
    selectedProjectId?: string;
};

function Layout({ children, activeTab, onTabChange, educationSubTab, networkingSubTab, userData, onChatSelect, onNewDirectChat, selectedChatId, selectedProjectId }: LayoutProps) {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

    return (
        <div className="layout">
            {/* iOS 26 Liquid Glass: real elements for Safari toolbar tinting */}
            <div className="safari-tint-top" aria-hidden="true" />
            <div className="safari-tint-bottom" aria-hidden="true" />

            {/* Mobile overlay — closes sidebar when tapping outside */}
            {!sidebarCollapsed && (
                <div
                    className="sidebar-overlay"
                    onClick={() => setSidebarCollapsed(true)}
                />
            )}
            <Sidebar
                activeTab={activeTab}
                onTabChange={onTabChange}
                isOpen={true}
                collapsed={sidebarCollapsed}
                onToggleCollapse={() => setSidebarCollapsed((v) => !v)}
                educationSubTab={educationSubTab}
                networkingSubTab={networkingSubTab}
                userData={userData}
                onChatSelect={onChatSelect}
                onNewDirectChat={onNewDirectChat}
                selectedChatId={selectedChatId}
                selectedProjectId={selectedProjectId}
            />
            <main className={`layout-main ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
                {children({
                    showMenu: true,
                    onMenuClick: () => setSidebarCollapsed((v) => !v),
                })}
            </main>
        </div>
    );
}

export default Layout;
